// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2cKOw","boxTitle":"Qualiphy_boxTitle__2nXrG","box":"Qualiphy_box__28MV2","toggleWrap":"Qualiphy_toggleWrap__3eQOq"};